import React, { Component, Fragment } from 'react'
import { BreadCrumb } from '../../components/BreadCrumb';
import { Translate } from '../../contexts/Language';
import { Card } from '../../components';
import DataTable from 'react-data-table-component'
import { DataTableColumns } from '../../config/DataTableColumns';
import { Config } from '../../config';
import { Service } from '../../services';

export class Dashboard extends Component {
    constructor() {
        super()
        this.state = {

            dashboard: {
                userInfo: {
                    fullName: "",
                    email: "",
                    ipAdress: ""
                },
                depositAuto: true,
                internalTransferAuto: true,
                transferHistory: [],
                dailyDeposit: [],
                dailyWithdrawal: []
            }

        }
    }
    componentDidMount() {
        Config.utilities.loadingFetch();

        Service.User.Dashboard().then(response => {
            if (response) {

                this.setState({
                    dashboard: response
                });

            }

            Config.utilities.loadingFetch();
        });
    }
    render() {
        return (
            <Fragment>
                <BreadCrumb Title={Translate('Home')} Description={Translate('Welcome to Personnel Panel')} />

                <div className="row">
                    <div className="col-md-12">

                    </div>
                    <div className="col-md-3">
                        <div className="row">
                            <div className="col-md-12">
                                <Card Title={Translate('Summary')} Description={Translate("Personnel panel status summary")} >
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="mb-4 mini-stat">
                                                <div className="float-left mini-stat-img mr-4 bg-info text-white">
                                                    <i className="fas fa-info font-30"></i>
                                                </div>
                                                <h6 className="text-ellipsis font-14"><i className="fas fa-user fas-center"></i> {this.state.dashboard.userInfo.fullName}</h6>
                                                <h6 className="text-ellipsis font-14" title="bates@trabilisim.com"><i className="fas fa-envelope fas-center"></i> {this.state.dashboard.userInfo.email}</h6>
                                                <h6 className="text-ellipsis font-14"><i className="fas fa-globe fas-center"></i> {this.state.dashboard.userInfo.ipAdress}</h6>
                                            </div>
                                            <div className="mb-4 mini-stat">
                                                <div className="float-left mini-stat-img mr-3 bg-dark text-white">
                                                    <i className="fas fa-cog font-30"></i>
                                                </div>
                                                <dl className="row pt-1">
                                                    <dt className="col-md-9">Deposit Transfer Manual </dt>
                                                    <dd className="col-md-3">{this.state.dashboard.depositAuto ? <span className="badge badge-danger font-14 ml-1 pb-1">OFF</span> : <span className="badge badge-success font-14 ml-1 pb-1">ON</span>}</dd>
                                                    <dt className="col-md-9">Internal Transfer Manual </dt>
                                                    <dd className="col-md-3">{this.state.dashboard.internalTransferAuto ? <span className="badge badge-danger font-14 ml-1 pb-1">OFF</span> : <span className="badge badge-success font-14 ml-1 pb-1">ON</span>}</dd>
                                                </dl>
                                            </div>
                                        </div>
                                    </div>
                                </Card>
                            </div>
                            <div className="col-md-12">
                                <div className="card mini-stat">
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <div className="float-left mini-stat-img mr-4 bg-warning text-white">
                                                <i className="fas fa-money-bill-alt font-30"></i>
                                            </div>
                                            <h5 className="font-16 text-uppercase mt-0">{Translate('Daily Withdrawal')}</h5>
                                            <h6 className="font-500">
                                                {this.state.dashboard.dailyWithdrawal.length === 0 ?
                                                    <span className="badge badge-light mr-1 font-14 pb-1">{Translate("No Withdrawal")}</span> :
                                                    this.state.dashboard.dailyWithdrawal.map(item => (
                                                        item.currency === "BTC"
                                                            ?
                                                            <span className="badge badge-light mr-1 font-14 pb-1" title={item.currency}>{item.total} {item.symbol}</span>
                                                            :
                                                            <span className="badge badge-light mr-1 font-14 pb-1" title={item.currency}>{item.total.format('c')} {item.symbol}</span>
                                                    ))
                                                }
                                            </h6>
                                        </div>
                                        <div className="pt-2">
                                            <p className=" mb-0">{Translate('Daily approved transactions')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="card mini-stat">
                                    <div className="card-body">
                                        <div className="mb-4">
                                            <div className="float-left mini-stat-img mr-4 bg-success text-white">
                                                <i className="fas fa-wallet font-30"></i>
                                            </div>
                                            <h5 className="font-16 text-uppercase mt-0">{Translate('Daily Deposit')}</h5>
                                            <h6 className="font-500">
                                                {this.state.dashboard.dailyDeposit.length === 0 ?
                                                    <span className="badge badge-light mr-1 font-14 pb-1">{Translate("No Deposit")}</span> :
                                                    this.state.dashboard.dailyDeposit.map(item => (
                                                        item.currency === "BTC"
                                                            ?
                                                            <span className="badge badge-light mr-1 font-14 pb-1" title={item.currency}>{item.total} {item.symbol}</span>
                                                            :
                                                            <span className="badge badge-light mr-1 font-14 pb-1" title={item.currency}>{item.total.format('c')} {item.symbol}</span>
                                                    ))
                                                }
                                            </h6>
                                        </div>
                                        <div className="pt-2">
                                            <p className="mb-0">{Translate('Daily approved transactions')}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                    <div className="col-md-9">
                        <Card Title={Translate('Latest Money Transfers')} Description={Translate("Last transfer transactions")} className="min-height-dashboard">

                            {this.state.dashboard.transferHistory.length === 0 ? (
                                <div className="alert alert-light" role="alert">
                                    <em><strong>{Translate('No Record')}!</strong> {Translate('No transfer history')}.</em>
                                </div>) :
                                (<DataTable
                                    noHeader={true}
                                    columns={DataTableColumns.transferHistory}
                                    data={this.state.dashboard.transferHistory}
                                    pagination
                                    paginationPerPage={9}
                                    highlightOnHover />)}

                        </Card>
                    </div>
                </div>
            </Fragment>
        )
    }
}